export const mergeArray = (a, b, prop, mergeProps = []) => {
  return a.map((aitem) => {
    const item = b.find((bitem) => {
      return aitem[prop] === bitem[prop]
    })
    if (item)
      mergeProps.forEach((p) => {
        aitem[p] = item[p]
      })
    return aitem
  })
}
